var _ = require('underscore');
var LayoutPerspective = require('./../layout/LayoutPerspective');
var TorsoEvents = require('backbone-torso/modules/Events');
var patientProfileLayoutTemplate = require('./patientProfileLayoutTemplate.hbs');
var PatientDemographicsView = require('./../demographics/PatientDemographicsView');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var AsideBehavior = require('./../aside/AsideBehavior');
var WizardAccessBehavior = require('./../wizard/WizardAccessBehavior');
var WizardPerspectiveBehavior = require('./../wizard/WizardPerspectiveBehavior');
var launcherAppInterface = require('./../launcherApplicationInterface');

var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');

/**
 * Perspective to display the patient profile to the patient.
 *
 * @class PatientProfilePerspective
 * @constructor
 * @param options {Object} Options to configure this perspective.
 *   @param [options.patientVecnaId] {String} the vecna id of the current patient
 *   @param [options.appointmentExternalId] {String} the external id of the current appointment
 *   @param [options.regDate] {String} the date of the appointments to preregister
 */
module.exports = LayoutPerspective.extend({
  template: patientProfileLayoutTemplate,

  behaviors: {
    portalPerspectiveLayoutBehavior: {
      behavior: PortalPerspectiveLayoutBehavior
    },
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: 'patient.profile.aside.header',
      asideContentMessageKey: function() {
        if (launcherAppInterface.isAtHospital()) {
          return 'patient.profile.aside.ereg';
        } else {
          return 'patient.profile.aside';
        }
      }
    },
    wizardAccessBehavior: WizardAccessBehavior,
    wizardPerspectiveBehavior: {
      behavior: WizardPerspectiveBehavior,
      pageName: WizardPerspectiveBehavior.PAGE_NAMES.PROFILE,
      continueAllowed: false
    },
    appointmentSecureMessage: {
      behavior: SecureMessageDataBehavior,
      returnSingleResult: true,
      ids: function(cache) {
        var appointmentExternalId = this.view._appointmentExternalId;
        if (!appointmentExternalId) {
          return { skipObjectRetrieval: true };
        }

        var patientVecnaId = this.view._patientVecnaId;
        var criteria = cache.getCriteriaForAppointmentIdAndExternalId(patientVecnaId, appointmentExternalId);
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      ids: { property: 'behaviors.appointmentSecureMessage.data:appointmentDTO.externalAppointment.type'}
    }
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this perspective.
   *   @param [options.patientVecnaId] {String} the vecna id of the current patient
   *   @param [options.appointmentExternalId] {String} the external id of the current appointment
   *   @param [options.regDate] {String} the date of the appointments
   *   @param [options.moduleNamespace] {String} the message key prefix to use.
   */
  initialize: function(options) {
    LayoutPerspective.prototype.initialize.apply(this);
    options = options || {};
    this.moduleNamespace = options.moduleNamespace;

    // These are set for the wizard behaviors.
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalId = options.appointmentExternalId;
    this._regDate = options.regDate;

    this._patientDemographicsView = new PatientDemographicsView({
      patientVecnaId: options.patientVecnaId,
      appointmentExternalId: this._appointmentExternalId,
      regDate: this._regDate
    });

    var isInPreReg = false;
    if (this._appointmentExternalId || this._regDate) {
      isInPreReg = true;
      this.listenTo(TorsoEvents, 'demographics:validate', this._validateAllChildContext);
    }
    this.getBehavior('wizardPerspectiveBehavior').setContentView(this._patientDemographicsView);
    this.getBehavior('wizardPerspectiveBehavior').isActive = isInPreReg;
    this._isInPreReg = isInPreReg;
  },

  /**
   * Validate all child context to determine if user is allowed to continue to next step in pre-reg wizard
   * @method _validateAllChildContext
   * @private
   */
  _validateAllChildContext: function() {
    var childViews = this._patientDemographicsView.getTrackedViews({ child: true });
    if (this._isInPreReg) {
      var isValid = true;
      _.each(childViews, function(childView) {
        var validationBehavior = childView.getBehavior('validationBehavior');
        if (validationBehavior) {
          isValid = isValid && childView.validate();
        }
      });
      this.getBehavior('wizardPerspectiveBehavior').getWizardWidget().setContinueAllowed(isValid);
    }
  }
});
